import React from "react"
import { withTheme } from "emotion-theming"

import {
  VIEWBOX_WIDTH,
  VIEWBOX_HEIGHT,
  VIEWBOX_HEIGHT_HALF,
  VIEWBOX_CENTER_X,
  VIEWBOX_CENTER_Y,
} from "./constants"

import Path from "./path"

import { Svg, Text } from "./styles"

const Circle = ({ theme, value, colour, text }) => {
  const getPathRadius = () => {
    return VIEWBOX_HEIGHT_HALF - 4
  }

  const getPathRatio = () => {
    const boundedValue = Math.min(Math.max(value, 0), 100)
    return (boundedValue - 0) / (100 - 0)
  }

  return (
    <Svg viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}>
      <Path
        dashRatio={getPathRatio()}
        pathRadius={getPathRadius()}
        colour={colour}
      />
      {text && (
        <Text x={VIEWBOX_CENTER_X} y={VIEWBOX_CENTER_Y} colour={colour}>
          {text}
        </Text>
      )}
    </Svg>
  )
}

export default withTheme(Circle)
